var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1573_4973)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM5.86407 8.89779L9.53548 3.54593C9.6817 3.33153 9.5497 3 9.25723 3H8.43954C8.19041 3 7.96282 3.12738 7.82305 3.33067L5.24729 7.08607L4.17105 5.51595C4.03024 5.30896 3.80011 5.18494 3.55432 5.18494H2.73663C2.44416 5.18494 2.3122 5.51651 2.45841 5.73091L4.6323 8.89802C4.70118 8.99902 4.79263 9.08229 4.89973 9.14014C5.00697 9.19805 5.12643 9.22857 5.24811 9.22857C5.36978 9.22857 5.48925 9.19805 5.59649 9.14014C5.70356 9.08231 5.7952 8.99875 5.86407 8.89779Z",
    fill: "#6CCDBC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1573_4973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.0670fd33a761eed76ceb956ef7e804bb.svg";
export { ForwardRef as ReactComponent };